import { render, staticRenderFns } from "./abstract-modal-header.vue?vue&type=template&id=2e10823d"
import script from "./abstract-modal-header.vue?vue&type=script&lang=js"
export * from "./abstract-modal-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports